import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import AdminAddDashboardsAreaPage from '@src/main/ui/pages/AdminAddDashboardsPage/AdminAddDashboardsAreaPage';
import AdminAddDashboardsAreasPage from '@src/main/ui/pages/AdminAddDashboardsPage/AdminAddDashboardsAreasPage';
import AdminAddDashboardsSubareaPage from '@src/main/ui/pages/AdminAddDashboardsPage/AdminAddDashboardsSubareaPage';
import AdminAddDashboardsSubsubareaPage from '@src/main/ui/pages/AdminAddDashboardsPage/AdminAddDashboardsSubsubareaPage';
import AreasMenuPage from '@src/main/ui/pages/AreasMenuPage/AreasMenuPage';
import AreasPage from '@src/main/ui/pages/AreasPage/AreasPage';
import DashboardPage from '@src/main/ui/pages/DashboardPage/DashboardPage';
import FavoritesPage from '@src/main/ui/pages/FavoritesPage/FavoritesPage';
import HomePage from '@src/main/ui/pages/HomePage/HomePage';
import LoginPage from '@src/main/ui/pages/LoginPage/LoginPage';
import ManageUsersPage from '@src/main/ui/pages/ManageUsersPage/ManageUsersPage';
import SearchPage from '@src/main/ui/pages/SearchPage/SearchPage';

import { ErrorPage } from '@src/main/ui/components/common/ErrorPage/ErrorPage';
import { NotFoundPage } from '@src/main/ui/components/common/NotFoundPage/NotFoundPage';
import LayoutWithNavbar from '@src/main/ui/components/layout/LayoutWithNavbar/LayoutWithNavbar';
import LayoutWithNavbarEmbed from '@src/main/ui/components/layout/LayoutWithNavbarEmbed/LayoutWithNavbarEmbed';
import ProtectedRoute from '@src/main/ui/components/layout/ProtectedRoute/ProtectedRoute';

import type React from 'react';

const publicRoutes = () => ({
  path: '/',
  errorElement: <ErrorPage />,
  element: <LayoutWithNavbar />,
  children: [
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: '/search',
      element: <SearchPage />,
    },
    {
      path: '/favorites',
      element: <FavoritesPage />,
    },
    {
      path: '/areas/:areaId/:subareaId',
      element: <AreasPage />,
    },
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/areas-menu',
      element: <AreasMenuPage />,
    },
  ],
});

const privateRoutes = () => ({
  path: '/',
  errorElement: <ErrorPage />,
  element: (
    <ProtectedRoute>
      <LayoutWithNavbar />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/admin/add-dashboards/areas',
      element: <AdminAddDashboardsAreasPage />,
    },
    {
      path: '/admin/add-dashboards/areas/:areaId',
      element: <AdminAddDashboardsAreaPage />,
    },
    {
      path: '/admin/add-dashboards/areas/:areaId/:subareaId',
      element: <AdminAddDashboardsSubareaPage />,
    },
    {
      path: '/admin/add-dashboards/areas/:areaId/:subareaId/:subsubareaId',
      element: <AdminAddDashboardsSubsubareaPage />,
    },
    {
      path: '/admin/manage-admin-users',
      element: <ManageUsersPage />,
    },
  ],
});

const router = createBrowserRouter([
  publicRoutes(),
  privateRoutes(),
  {
    path: '/',
    errorElement: <ErrorPage />,
    element: <LayoutWithNavbarEmbed />,
    children: [
      {
        path: '/dashboard/:dashboardId',
        element: <DashboardPage />,
      },
    ],
  },
  {
    path: '/',
    errorElement: <ErrorPage />,
    element: <LayoutWithNavbar />,
    children: [
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);

function Router(): React.ReactElement {
  return <RouterProvider router={router} />;
}

export { Router };
